import axios from 'axios'
import router from './router'

export default function setup() {
  axios.interceptors.request.use(
    function(config) {
      let token = localStorage.getItem('token')
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`
      }
      return config
    },
    function(error) {
      // Do something with request error
      return Promise.reject(error)
    }
  )
  axios.interceptors.response.use(
    function(response) {
      return response
    },
    function(error) {
      switch (error.response.status) {
        case 401:
          localStorage.removeItem('token')
          router.push({ path: '/' })
          break
        case 500:
          alert('Сервер в данный момент не доступен! Обратитесь к админимстратору!')
          break
        case 502:
          alert('Сервер в данный момент не доступен! Обратитесь к админимстратору!')
          break
        case 504:
          alert('Сервер в данный момент не доступен! Обратитесь к админимстратору!')
          break
      }
      return Promise.reject(error)
    }
  )
}



// WEBPACK FOOTER //
// ./src/axios.js